<div class="lawyer-avatar__wrapper" *ngIf="avatar">
  <img alt="" [src]="avatar" loading="lazy" [style]="style" (error)="onErrorLoadImage($event)" />
</div>
<div *ngIf="!hideStatus" class="lawyer-avatar__status" [class]="[size, online ? 'online' : '']"></div>
<div class="lawyer-avatar__badge" *ngIf="premium">
  <span>{{ 'components.lawyerAvatar.premium' | translate }}</span>
</div>
